<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Rise of the Tang Dynasty</title>
<link href="../style/9781473887794.css" rel="stylesheet" type="text/css"/>
<h2 class="fm-head"><a id="page_vii"></a><span class="bold">Acknowledgements</span></h2>
<h4 class="h4"><span class="bold">Special Thanks</span></h4>
<p class="noindent"><span class="dropcap">I</span> need to thank my editor, Philip Sidnell, for his interest and encouragement. I deeply appreciate his handling of my work. I also want to thank Matt Jones, Amy Jordan, and Clive Watson of Pen &amp; Sword for their care and hard work making my manuscript into a book.</p>
<p class="indent">I also want to thank two people who are long gone but who directed my attention to the beauty and importance of the Chinese people. Both were teachers at Beloit College in the early Sixties. The first is Professor Gustav Johnson, who spent the Second World War in China. He brought an immediacy and broader vision of current events in China following that war. The second is that prince of historians, Bob Irrmann; always insightful, he spent time discussing the image of Chinese society pictured in Bland and Backhouse’s <em class="italic">China under the Empress Dowager</em> and lent me a copy of Der Ling’s <em class="italic">Old Buddha</em>, another image of Tzu Hsi.</p>
<p class="indent">I thank my wife, Judy, for her forbearance and patience that allowed me to write this book.</p>
<p class="indent">Any errors in this work are mine alone.<a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?f4b257e4